var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckboxInputChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.625,
    y: 2.625,
    width: 18.75,
    height: 18.75,
    rx: 3.375,
    fill: "#6E42FF",
    stroke: "#6728FF",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.458 15.8398C11.1878 15.8398 10.96 15.7292 10.7744 15.5078L8.3916 12.5977C8.31348 12.5065 8.25814 12.4202 8.22559 12.3389C8.19303 12.2542 8.17676 12.1647 8.17676 12.0703C8.17676 11.8685 8.24512 11.7008 8.38184 11.5674C8.51855 11.4339 8.69108 11.3672 8.89941 11.3672C9.13379 11.3672 9.3291 11.4632 9.48535 11.6553L11.4385 14.0967L15.2666 8.04199C15.3545 7.90527 15.4473 7.80924 15.5449 7.75391C15.6426 7.69531 15.763 7.66602 15.9062 7.66602C16.1146 7.66602 16.2855 7.73275 16.4189 7.86621C16.5524 7.99642 16.6191 8.16243 16.6191 8.36426C16.6191 8.43913 16.6061 8.51888 16.5801 8.60352C16.554 8.6849 16.5133 8.76953 16.458 8.85742L12.1465 15.4834C11.987 15.721 11.7575 15.8398 11.458 15.8398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckboxInputChecked);
export default __webpack_public_path__ + "static/media/ic_checkbox_input_checked.3794f6395f3ef310fdc14fbd8a092ecb.svg";
export { ForwardRef as ReactComponent };